module.exports = __webpack_public_path__ + "img/tag-detail-bg.908009ce.png";